import { LuSearch, LuChevronDown } from "@/Components/Icons/Icons";

export default {
  row1: [
    {
      column: "column1",
      rows: {
        row1: [
          {
            name: "eSanchitDocumentLevel",
            label: "Document Level",
            component: "dropdown",
            endIconName: LuChevronDown,
            options: [
              { label: "Job", value: "Job" },
              { label: "Invoice", value: "Invoice" },
              { label: "Item", value: "Item" },
            ],
          },
          {
            name: "eSanchitInvsrNo",
            label: "Inv.Sr.No",
            component: "text-field",
            icon: LuSearch,
            type: "autocomplete",
            endpoint: "getESanchitInvoiceQuery",
          },
          {
            name: "eSanchitItemSrNo",
            label: "Item.Sr.No",
            component: "text-field",
            icon: LuSearch,
            type: "autocomplete",
            endpoint: "getDescription",
          },
        ],
        row2: [
          {
            name: "eSanchitScope",
            label: "Scope",
            component: "dropdown",
            width: "32%",
            options: [
              { label: "This Job Only", value: "This Job Only" },
              { label: "Multiple Jobs", value: "Multiple Jobs" },
            ],
          },
        ],
        row3: [
          {
            name: "eSanchitIRN",
            label: "IRN(Image Ref.No.)",
            component: "text-field",
            width: "50%",
          },
          {
            name: "eSanchitDocumentType",
            label: "Document Type",
             component: "text-field",
            type: "autocomplete",
            width: "50%",
            endpoint: "getESanchitDocument",
            required: true,
          },
        ],
        row4: [
          {
            name: "eSanchitIcegateId",
            label: "ICEGATE ID",
            component: "dropdown",
            endIconName: LuChevronDown,
            width: "50%",
            options: [
              {
                label: "AAGCR9244LPSU00 - FCard - admin",
                value: "AAGCR9244LPSU00",
              },
              {
                label: "AAHCA3430APSU00 - FCard - Avalon",
                value: "AAHCA3430APSU00",
              },
              {
                label: "AAPCS7948KPSU00 - FCard - admin",
                value: "AAPCS7948KPSU00",
              },
              {
                label: "AAPCS7948KPSU02 - FCard - admin",
                value: "AAPCS7948KPSU02",
              },
              {
                label: "ARUNKUMBHARE1973 - GCard - ARUNKUMBHARE1973",
                value: "ARUNKUMBHARE1973",
              },
              {
                label: "BLRTRIPATHI - FCard - BLRTRIPATHI",
                value: "BLRTRIPATHI",
              },
              { label: "BOMTRIPATH - FCard - BOMTRIPATH", value: "BOMTRIPATH" },
              { label: "DELTRIPATH - FCard - DELTRIPATH", value: "DELTRIPATH" },
              {
                label: "HPPPSEZZAIR - FCard - HPPPSEZZAIR",
                value: "HPPPSEZZAIR",
              },
              { label: "HPPPSEZCHA - FCard - HPPPSEZCHA", value: "HPPPSEZCHA" },
              {
                label: "SANDESHGORULE1987 - GCard - SANDESHGORULE1987",
                value: "SANDESHGORULE1987",
              },
              { label: "TRIPATHAMD - GCard - TRIPATHAMD", value: "TRIPATHAMD" },
              { label: "TRIPATHBLR - FCard - TRIPATHBLR", value: "TRIPATHBLR" },
              {
                label: "TRIPATHBLR1 - GCard - TRIPATHBLR1",
                value: "TRIPATHBLR1",
              },
              {
                label: "TRIPATHBLR2 - FCard - TRIPATHBLR2",
                value: "TRIPATHBLR2",
              },
              {
                label: "TRIPATHCCU123 - GCard - TRIPATHCCU123",
                value: "TRIPATHCCU123",
              },
              { label: "TRIPATHHYD - FCard - TRIPATHHYD", value: "TRIPATHHYD" },
              { label: "TRIPATHMAA - FCard - TRIPATHMAA", value: "TRIPATHMAA" },
              { label: "Other", value: "Other" },
            ],
            required: true,
          },
          {
            name: "eSanchitOtherIcegateId",
            label: "OTHER ICEGATE ID",
            component: "text-field",
            width: "50%",
            required: true,
          },
        ],
        row5: [
          {
            name: "eSanchitICegateFileName",
            label: "ICEGATE Filename",
            component: "text-field",
            width: "50%",
          },
          {
            name: "eSanchitFileType",
            label: "File Type",
            component: "text-field",
            width: "50%",
          },
        ],
        row6: [
          {
            name: "eSanchitDatetimeupload",
            label: "Date-Time of Upload",
            component: "datetimeselector",
            width: "50%",
          },
        ],
        row7: [
          {
            name: "eSanchitDocumentRefNo",
            label: "Document Reference No",
            component: "text-field",
            width: "50%",
          },
          {
            name: "eSanchitPlaceofIssue",
            label: "Place of Issue",
            component: "text-field",
            width: "50%",
            required: true,
          },
        ],
        row8: [
          {
            name: "eSanchitDateofIssue",
            label: "Date of Issue",
            component: "dateselector",
            width: "50%",
            required: true,
          },
          {
            name: "eSanchitExpiryDate",
            label: "Expiry Date",
            component: "dateselector",
            width: "50%",
          },
        ],
        row9: [
          {
            name: "Issuing Party Details",
            component: "header",
            label: "Issuing Party Details",
          },
          {
            name: "Beneficiary Party Details",
            component: "header",
            label: "Beneficiary Party Details",
          },
        ],
        row10: [
          {
            name: "eSanchitIssuingName",
            label: "Name",
            component: "text-field",
            width: "50%",
            icon: LuSearch,
            type: "autocomplete",
            endpoint: "getCustomers",
            autofillTargets: {
              eSanchitIssuingAddressLine1: "addressLine",
              eSanchitIssuingCityName: "city",
              issuingCustomerPostalCode: "pincode",
            },
            endPointWithId : "getCustomersAddress"
          },

          {
            name: "eSanchitbeneficiaryName",
            label: "Name",
            component: "text-field",
            width: "50%",
            icon: LuSearch,
            endpoint: "getCustomers",
            type: "autocomplete",
            autofillTargets: {
              eSanchitbeneficiaryAddressLine1: "addressLine",
              eSanchitbeneficiaryCityName: "city",
              beneficiaryCustomerPostalCode: "pincode",
            },
            endPointWithId : "getCustomersAddress"
          },
        ],
        row11: [
          {
            name: "eSanchitIssuingcode",
            label: "Code",
            component: "text-field",
            width: "50%",
          },
          {
            name: "eSanchitbeneficiarycode",
            label: "Code",
            component: "text-field",
            width: "50%",
          },
        ],
        row12: [
          {
            name: "eSanchitIssuingAddressLine1",
            label: "Address Line.1",
            component: "text-field",
            width: "50%",
          },
          {
            name: "eSanchitbeneficiaryAddressLine1",
            label: "Address Line.1",
            component: "text-field",
            width: "50%",
          },
        ],
        row13: [
          {
            name: "eSanchitIssuingAddressLine2",
            label: "Address Line.2",
            component: "text-field",
            width: "50%",
          },
          {
            name: "eSanchitbeneficiaryAddressLine2",
            label: "Address Line.2",
            component: "text-field",
            width: "50%",
          },
        ],
        row14: [
          {
            name: "eSanchitIssuingCityName",
            label: "City",
            component: "text-field",
            width: "50%",
            type: "autocomplete",
            endpoint: "getCityMaster",
          },
          {
            name: "eSanchitbeneficiaryCityName",
            label: "City",
            component: "text-field",
            width: "50%",
            type: "autocomplete",
            endpoint: "getCityMaster",
          },
        ],
        row15: [
          {
            name: "eSanchitIssuingpincode",
            label: "Pin Code",
            component: "text-field",
            width: "50%",
          },
          {
            name: "eSanchitbeneficiarypincode",
            label: "Pin Code",
            component: "text-field",
            width: "50%",
          },
        ],
        row16: [
          {
            name: "eSanchitAttachmentId",
            label: "Unsigned Document PDF",
            component: "fileselector",
            width: "50%",
            allowedFileTypes: "PDF",
          },
          {
            name: "unsignedPdfAction",
            label: "Action",
            component: "outlinebutton",
            width: "20%",
            sx: { mt: "33px" },
          },
        ],
      },
    },
  ],
};
